<template>
    <div class="info" :style="{background:'url('+ bg + ') no-repeat center top',backgroundSize:'100% auto'}">
        <div class="main-flex">
            <el-row align="middle">
                <!-- 左侧文字区域 -->
                <el-col :md="12" class="admission">
                    <div class="text-inner">
                        <YYTitle :yyMsg="yyMessage" class="hidden-xs-only"></YYTitle>
                        <XSTitle :main="yyMessage" :sub="titEN" class="hidden-sm-and-up"></XSTitle>
                        <div class="infoText">
                            <p v-for="(item,index) in p" :key="index" :class="index==1?'hidden-xs-only':null">{{item}}</p>
                        </div>
                        <MoreButton @toLink="parentLink" aria-label="查看山东医影智能公司详细介绍"></MoreButton>
                    </div>
                </el-col>
                <!-- 右侧圆形图片 -->
                <el-col :md="12" class="admission_b">
                    <div class="imgPart hidden-sm-and-down">
                        <img 
                            :src="img" 
                            alt="山东医影智能科技有限公司 医学影像仿真设备企业形象图"
                            loading="lazy"
                            decoding="async"
                        >
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import YYTitle from '../yyTitle.vue'
import XSTitle from '../eyTitXs.vue'
import MoreButton from './moreButton.vue'

export default {
    props:{
        bg: String
    },
    components:{
        YYTitle,
        XSTitle,
        MoreButton
    },
    data(){
        return{
            yyMessage: '公司介绍',
            titEN:'COMPANY INTRODUCTION',
            p:[
                "山东医影智能科技有限公司简称“医影智能”，专注医学影像虚拟仿真技术研发。团队从业人员拥有多年医学影像教学与临床实践经验，聘请多名中华医学会影像技术分会、放射学分会专家担任顾问，为医学影像虚拟仿真项目研发提供专业技术支撑。",
                "公司主营四大产品线：①医学影像虚拟仿真软件：医学影像中心VR系统、MRI/CT/DR设备结构仿真、性能检测仿真、影像检查技术虚拟仿真系统；②医学影像云平台；③医学图像处理教学系统；④医学影像实训硬件：MRI教学机、CT教学机、DR设备等医学影像教学实训设备。",
            ],
            img:require('@/assets/employ/logo1.1.png')
        }
    },
    methods:{
        parentLink(){
            this.$router.replace('/about')
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }
}
</script>

<style lang="scss" scoped>
.info{
    width: 100%;
    margin: vw(63) 0 vw(14) 0;
    padding: vw(80) 0;
    background-color: #fff;
    position: relative;

    // 主容器：90%宽度 水平居中
    .main-flex {
        width: 83%;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    // 左侧文字区域
    .admission {
        animation: fadeInLeft 1.6s ease-out forwards;

        .text-inner {
            padding-right: vw(60); // 拉开与右侧图片的间距
        }
    }
    @keyframes fadeInLeft {
      0% {
        transform: translateX(-40px);
        opacity: 0;
      }
      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }

    // 右侧图片区域
    .admission_b {
        animation: fadeInRight 1.6s ease-out 0.2s forwards;
        margin-top: 30px;
    }
    @keyframes fadeInRight {
      0% {
        transform: translateX(40px);
        opacity: 0;
      }
      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }

    .infoText{
        margin-bottom: vw(40);

        p{
            font-size: vw(20);
            color: #222;
            margin: 0;
            text-align: left;
            line-height: 2;
            word-wrap: break-word;

            &:first-child{
                margin-bottom: 1.8rem;
            }
        }
    }

    // 圆形图片美化
    .main-flex .imgPart{
        width: vw(518);
        height: vw(510);
        margin-left: auto; // 图片靠右对齐，自然拉开间距
        transition: transform 0.4s ease;
        

        img{
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover; // 防止图片拉伸变形
            box-shadow: 0 8px 30px rgba(37, 99, 175, 0.15);
        }

        &:hover {
            transform: scale(1.02); //  hover轻微放大
        }
    }

    // 穿透子组件样式美化
    ::v-deep {
        .cusTitle{
            font-size: vw(36);
            text-align: left;
            color: $font30;
            margin-bottom: vw(50);
            position: relative;

            &:after{
                content: "";
                position: absolute;
                left: 0;
                bottom: -12px;
                width: vw(189);
                height: 4px;
                background: $yyBlue;
                border-radius: 2px;
            }
        }

        .moreBu{
            padding: vw(12) vw(40);
            color: white;
            font-size: vw(16);
            border-radius: 8px;
            background: linear-gradient(180deg, rgba(37,99,175,.8), $yyBlue);
            transition: all 0.25s ease;
            border: none;
            cursor: pointer;

            &:hover{
                box-shadow: 0 6px 20px rgba(37,99,175,.25);
                transform: translateY(-2px);
            }

            &:active{
                transform: translateY(0);
                background: linear-gradient(180deg, $yyBlue, rgba(37,99,175,.8));
            }
        }
    }

    // -------------------------------  手机端适配  -------------------------------
    @media only screen and (max-width: 767px){
        padding: vp(50) 0;

        .admission .text-inner {
            padding-right: 0;
        }

        .infoText{
            p{
                font-size: vp(24);
                line-height: 1.8;
            }
        }

        .main-flex .imgPart {
            width: vp(320);
            height: vp(320);
            margin: vp(40) auto 0;
        }

        ::v-deep {
            .cusTitle {
                font-size: vp(32);
                margin-bottom: vp(40);
            }

            .moreBu{
                margin: 0 auto;
                display: block;
            }
        }
    }
}
</style>